var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from 'lit/decorators.js';
import { html } from 'lit';
import { SgdfElement } from '../../internal/sgdf-element.js';
import styles from './table-filter.styles.js';
import '../debounced-input/debounced-input.js';
/**
 * @summary Short summary of the component's intended use.
 * @status experimental
 * @since 1.0
 *
 * @dependency sgdf-example
 *
 * @event sgdf-event-name - Emitted as an example.
 *
 * @slot - The default slot.
 * @slot example - An example slot.
 *
 * @csspart base - The component's base wrapper.
 *
 * @cssproperty --example - An example CSS custom property.
 */
class SgdfTableFilter extends SgdfElement {
    constructor() {
        super(...arguments);
        this.table = null;
        this.type = null;
        this.columnFilterValue = '';
        this.sortedUniqueValues = [];
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        if (!this.type) {
            return null;
        }
        if (this.type === 'number') {
            return html ` <div>
                <div>
                    <sgdf-debounced-input
                        type="number"
                        min=${Number((_b = (_a = this.column.getFacetedMinMaxValues()) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : '')}
                        max=${Number((_d = (_c = this.column.getFacetedMinMaxValues()) === null || _c === void 0 ? void 0 : _c[1]) !== null && _d !== void 0 ? _d : '')}
                        value=${(_f = (_e = this.columnFilterValue) === null || _e === void 0 ? void 0 : _e[0]) !== null && _f !== void 0 ? _f : ''}
                        @sgdf-debounced-input=${(value) => this.column.setFilterValue((old) => [
                Number(value.detail),
                old === null || old === void 0 ? void 0 : old[1],
            ])}
                        placeholder=${`Min ${((_g = this.column.getFacetedMinMaxValues()) === null || _g === void 0 ? void 0 : _g[0])
                ? `(${(_h = this.column.getFacetedMinMaxValues()) === null || _h === void 0 ? void 0 : _h[0]})`
                : ''}`}
                    ></sgdf-debounced-input>
                    <sgdf-debounced-input
                        type="number"
                        min=${Number((_k = (_j = this.column.getFacetedMinMaxValues()) === null || _j === void 0 ? void 0 : _j[0]) !== null && _k !== void 0 ? _k : '')}
                        max=${Number((_m = (_l = this.column.getFacetedMinMaxValues()) === null || _l === void 0 ? void 0 : _l[1]) !== null && _m !== void 0 ? _m : '')}
                        value=${(_p = (_o = this.columnFilterValue) === null || _o === void 0 ? void 0 : _o[1]) !== null && _p !== void 0 ? _p : ''}
                        @sgdf-debounced-input=${(value) => this.column.setFilterValue((old) => [
                old === null || old === void 0 ? void 0 : old[0],
                Number(value.detail),
            ])}
                        placeholder=${`Max ${((_q = this.column.getFacetedMinMaxValues()) === null || _q === void 0 ? void 0 : _q[1])
                ? `(${(_r = this.column.getFacetedMinMaxValues()) === null || _r === void 0 ? void 0 : _r[1]})`
                : ''}`}
                    ></sgdf-debounced-input>
                </div>
            </div>`;
        }
        return html `
            <sgdf-debounced-input
                type="text"
                value=${((_s = this.columnFilterValue) !== null && _s !== void 0 ? _s : '')}
                placeholder=${`Rechercher... (${this.column.getFacetedUniqueValues().size})`}
                .list=${this.sortedUniqueValues}
            ></sgdf-debounced-input>
        `;
    }
}
SgdfTableFilter.styles = styles;
export default SgdfTableFilter;
__decorate([
    property({ type: Object, reflect: true })
], SgdfTableFilter.prototype, "column", void 0);
__decorate([
    property({ type: Object, reflect: true })
], SgdfTableFilter.prototype, "table", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfTableFilter.prototype, "type", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfTableFilter.prototype, "columnFilterValue", void 0);
__decorate([
    property({ type: Array, reflect: true })
], SgdfTableFilter.prototype, "sortedUniqueValues", void 0);
//# sourceMappingURL=table-filter.component.js.map